import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useTranslation } from "react-i18next";
import { CircularProgress } from "@mui/material";
import { ClientURI } from "../../shared";

const Input = styled.input`
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 60px;
  margin-bottom: 10px;
  outline: none;
`;
const InputButton = styled.div`
  display: flex;
  position: relative;
`;
const Button2 = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 10px;
  padding-left: 15px;
  padding-right: 15px;
  position: absolute;
  right: ${(props) => (props.hasSuggestions ? "-400px" : "1px")};
  top: 41%;
  transform: translateY(-50%);
  background-color: white;
  border-radius: 50% 50% 50% 50%;
  border: 0px solid gray !important;
  box-shadow: -5px 0 10px rgba(0, 0, 0, 0.1);
  color: #403f3f;
`;
const Button = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 9px;
  padding-left: 10px;
  padding-right: 10px;
  position: absolute;
  right: ${(props) => (props.hasSuggestions ? "-400px" : "1px")};
  top: 40%;
  transform: translateY(-50%);
  background-color: white;
  border-radius: 50% 50% 50% 50%;
  border: 0px solid gray !important;
  box-shadow: -5px 0 10px rgba(0, 0, 0, 0.1);
  color: #403f3f;
`;
const List = styled.div`
  list-style-type: none;
  padding: 0;
  margin: 0;
  width: 60%; /* Set width to 80% */
  position: absolute;
  left: 22%; /* Position the list at the center */
  z-index: 1001;
  background-color: #ffffff;
  border-radius: 8px;
  max-height: 90%;
  overflow-y: auto; /* Scroll when the list exceeds the max height */
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1); /* Soft, professional shadow */
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.3s ease-out, transform 0.3s ease-out; /* Smooth fade-in and slide-up */
  background: #fff;
  margin-top: 4px; /* Slight margin to give the dropdown some breathing space */

  @media (max-width: 480px) {
    width: 95%; /* Ensure the list takes full width on smaller screens */
    left: 0;
    margin: 8px; /* Align to left for smaller screens */
    transform: none; /* Remove centering for small devices */
  }
`;
const ListItem = styled.div`
  padding: 12px 20px;
  font-size: 15px;
  font-weight: 500;
  color: #333;
  cursor: pointer;
  display: flex;
  align-items: center;
  min-height: 48px; /* Maintain consistent height */
  transition: all 0.3s ease; /* Smooth hover and active transitions */

  /* Add a subtle line between each item */
  border-bottom: 1px solid #e0e0e0; /* Light gray border between items */

  &:hover {
    background-color: #f4f7fa; /* Soft hover effect */
    padding-left: 24px; /* Expand padding on hover */
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1); /* Soft shadow on hover */
  }

  &:active {
    background-color: #e7eff4; /* Slightly darker blue on click */
    transform: scale(0.98); /* Shrink effect when clicked */
  }

  &:focus {
    outline: none;
    background-color: #e0f7fa; /* Light blue for focus */
  }

  /* Optional: Icon Styling */
  & > .icon {
    margin-right: 12px;
    font-size: 18px;
    color: #0077cc; /* Icon color */
  }

  /* Remove border on the last item */
  &:last-child {
    border-bottom: none;
  }
`;
const AddressIn = styled.div`
  width: ${(props) => props.width};
  @media (max-width: 480px) {
    width: 100%;
  }
`;

const AddressInput = ({
  onSelectLocation,
  calculateDistanceFn,
  width,
  inputValue2,
}) => {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [isGeolocationLoading, setIsGeolocationLoading] = useState(false);

  const MAPBOX_ACCESS_TOKEN =
    "pk.eyJ1Ijoib3Vzc2FtYTAwOSIsImEiOiJjbHJodmFkc3gwMnZ6MmtwYWVqa2x6Yjl6In0.lPX7JfDDroOFDJh_DpSFYQ";
  useEffect(() => {
    inputValue2(inputValue);
  }, [inputValue]);
  useEffect(() => {
    if (selectedLocation) {
      onSelectLocation(selectedLocation);
      calculateDistanceFn(selectedLocation);
    }
  }, [selectedLocation]);

const getLocationByIP = async () => {
  try {
    // Try your backend first
    const backendResponse = await fetch(`${ClientURI}/geolocations`);
    if (!backendResponse.ok) throw new Error('Backend geolocation failed');
    
    const backendData = await backendResponse.json();
    console.log("Réponse du backend:", backendData);  // Log des données du backend
    return {
      coords: {
        latitude: backendData.latitude,
        longitude: backendData.longitude
      },
      city: backendData.city,
      country: backendData.country_code.toLowerCase()
    };
  } catch (backendError) {
    console.warn("Using fallback geolocation service", backendError);
    
    // Fallback to external service
    const externalResponse = await fetch('https://ipapi.co/json/');
    const externalData = await externalResponse.json();
    console.log("Réponse du service externe:", externalData);  // Log des données externes
    
    return {
      coords: {
        latitude: externalData.latitude,
        longitude: externalData.longitude
      },
      city: externalData.city,
      country: externalData.country_code.toLowerCase()
    };
  }
};


  const handleInputChange = async (value) => {
    setInputValue(value);
    try {
      const response = await axios.get(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
          value
        )}.json?access_token=${MAPBOX_ACCESS_TOKEN}`
      );
      if (response.data.features) {
        const suggestions = response.data.features.map((feature) => ({
          label: feature.place_name,
          value: {
            lat: feature.center[1],
            lon: feature.center[0],
          },
        }));
        setOptions(suggestions);
      }
    } catch (error) {
      console.error("Error fetching location suggestions:", error.message);
    }
  };

  const handleLocationChange = (location) => {
    setInputValue(location.label);
    setSelectedLocation(location);
    setOptions([]);
    calculateDistanceFn(location);
  };
  const Delete = () => {
    setInputValue("");
    setOptions([]);
  };

const handleLocationChange2 = async () => {
  setIsGeolocationLoading(true);
  try {
    // 1. Essayer la détection par IP d'abord
    const ipLocation = await getLocationByIP();
    const country = ipLocation?.country;
    
    // 2. Si Tunisie ou détection IP échouée, utiliser GPS
    let coordsToUse = ipLocation?.coords;
    
    if (!coordsToUse || country === 'tn') {
      try {
        const gpsPos = await getGPSCoordinates();
        coordsToUse = gpsPos.coords;
      } catch (gpsError) {
        console.error("GPS failed:", gpsError);
        if (!coordsToUse) throw new Error(t("Please enable GPS or enter address manually"));
      }
    }

    // 3. Reverse geocoding avec les coordonnées obtenues
    await reverseGeocode(coordsToUse.latitude, coordsToUse.longitude);
    
  } catch (error) {
    console.error("Location error:", error);
    alert(error.message);
  } finally {
    setIsGeolocationLoading(false);
  }
};

// Fonction séparée pour la récupération des coordonnées GPS
const getGPSCoordinates = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Geolocation not supported"));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      resolve,
      (err) => {
        reject(new Error(
          err.code === err.PERMISSION_DENIED 
            ? "Permission denied. Please enable GPS." 
            : "Unable to get GPS position"
        ));
      },
      {
        enableHighAccuracy: true,
        timeout: 15000, // 15 secondes timeout
        maximumAge: 0
      }
    );
  });
};
  const reverseGeocode = async (lat, lng) => {
    try {
      const response = await axios.get(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json?access_token=${MAPBOX_ACCESS_TOKEN}`
      );
      
      if (response.data.features?.length > 0) {
        const address = response.data.features[0].place_name;
        const location = {
          label: address,
          value: { lat, lon: lng },
        };

        setInputValue(location.label);
        setSelectedLocation(location);
        setOptions([]);
        calculateDistanceFn(location);
      }
    } catch (error) {
      console.error("Reverse geocoding error:", error);
      alert(t("Error fetching address details. Please try again."));
    }
  };

  return (
    <AddressIn width={width ? width : "100%"}>
      <InputButton>
      {inputValue === "" && (
          <Button onClick={handleLocationChange2} disabled={isGeolocationLoading}>
            {isGeolocationLoading ? (
              <CircularProgress size={20} /> // Add a loading indicator
            ) : (
              <LocationOnIcon style={{ color: "#eb1700" }} />
            )}
          </Button>
        )}
        {inputValue !== "" && <Button2 onClick={Delete}> ✖</Button2>}
        <Input
          type="text"
          value={inputValue}
          onChange={(e) => handleInputChange(e.target.value)}
          placeholder={t("type your address")}
          onKeyDown={(e) => e.stopPropagation()}
        />
      </InputButton>
      <List>
        {options.map((option, index) => (
          <ListItem key={index} onClick={() => handleLocationChange(option)}>
            {/* Optional icon */}
            <LocationOnIcon className="icon" style={{ color: "red" }} />
            <span>{option.label}</span>
            {/* Optionally add extra info like distance, address, etc */}
            <span>{option.distance || ""}</span>
          </ListItem>
        ))}
      </List>
    </AddressIn>
  );
};

export default AddressInput;
